module.exports = __webpack_public_path__ + "img/icon-num1.5689b1c0.png";